import { IS_STORYBOOK } from 'shared/consts/env'
import { overwriteMerge } from 'shared/utils/mergeUtils'
import deepmerge from 'deepmerge'
import {
  FETCH_PAYMENTS_METHODS_SUCCESS,
  FETCH_PAYMENT_METHODS_REQUEST,
  PAYMENT_DETAILS_SUCCESS,
  PAYMENT_SAVE_SUCCESS,
  PAYMENT_RESULT_CODE_ERROR,
  SET_PAYMENT_METHOD_SUCCESS,
  PAYMENTS_SUCCESS,
  REMOVE_PAYMENT_RESULT,
  SET_PAYMENT_AUTHORIZATION_LOADING,
  SHOW_PAYMENT_ERROR,
  SHOW_NO_PAYMENT_METHODS_AVAILABLE_ERROR
} from 'shared/store/ducks/checkout/payment'
import {
  FETCH_NEW_CUSTOMER_SUCCESS,
  FETCH_REDPOINTS_STATUS_SUCCESS,
  SET_REDPOINTS_REGISTRATION
} from 'shared/store/ducks/checkout/redpoints'
import {
  FETCH_ORDERDRAFT_SUCCESS,
  SELECT_SHIPPING_OPTION,
  SET_PHONENUMBER,
  SET_SHIPPING_OPTION_INFO,
  UPDATE_ORDERDRAFT
} from 'shared/store/ducks/checkout/orderDraft'
import {
  ADD_ADDRESS,
  CHANGE_ADDRESS_SUCCESS,
  FETCH_DOOR_DELIVERY_ADDRESSES_REQUEST,
  FETCH_DOOR_DELIVERY_ADDRESSES_SUCCESS,
  FETCH_PUP_ADDRESSES_REQUEST,
  FETCH_PUP_ADDRESSES_SUCCESS,
  SET_ADDRESS_TYPE,
  SET_DEFAULT_SHIPPING_ADDRESS_ID,
  SET_SHIPPING_ADDRESS_INFO
} from 'shared/store/ducks/checkout/address'
import { FETCH_SHIPPING_OPTIONS_SUCCESS } from 'shared/store/ducks/checkout/shipse'
import {
  CHECKOUT_ERROR,
  SET_CURRENT_STEP,
  SHOW_ORDER_SERVICE_UNAVAILABLE_ERROR
} from 'shared/store/ducks/checkout/common'
import { CheckoutAction, IState } from 'types/redux'

// TODO: create initial state
// REDUCER: modify state according to dispatched actions
// eslint-disable-next-line complexity
const reducer = (state: IState | {} = {}, action: CheckoutAction) => {
  switch (action?.type ?? '') {
    // Debugging only!
    case 'DEBUG_STATE':
      return deepmerge(
        state,
        action.state,
        action.overwriteMerge ? { arrayMerge: overwriteMerge } : undefined
      )
    case REMOVE_PAYMENT_RESULT:
    case PAYMENT_DETAILS_SUCCESS:
    case PAYMENT_RESULT_CODE_ERROR:
    case PAYMENTS_SUCCESS:
      return deepmerge(state, {
        paymentResult: action.paymentResult
      })
    case PAYMENT_SAVE_SUCCESS:
      return state
    case SET_PAYMENT_METHOD_SUCCESS:
      return deepmerge(state, {
        payment: action.payment
      })
    case FETCH_PAYMENT_METHODS_REQUEST:
      return deepmerge(state, {
        isPaymentLoading: true
      })
    case FETCH_PAYMENTS_METHODS_SUCCESS:
      return deepmerge(
        state,
        {
          blockedPaymentMethods: action.blockedPaymentMethods,
          paymentMethodEntries: action.paymentMethodEntries,
          isPaymentLoading: false,
          unavailableServices: action.unavailableServices
        },
        { arrayMerge: overwriteMerge }
      )
    case SET_PAYMENT_AUTHORIZATION_LOADING:
      return deepmerge(state, {
        isPaymentAuthorizationLoading: action.isPaymentAuthorizationLoading
      })
    case SHOW_PAYMENT_ERROR:
      return deepmerge(state, {
        showPaymentError: action.showPaymentError
      })
    case SHOW_NO_PAYMENT_METHODS_AVAILABLE_ERROR:
      return deepmerge(state, {
        showNoPaymentMethodsAvailableError:
          action.showNoPaymentMethodsAvailableError
      })
    // SHOW_ORDER_SERVICE_UNAVAILABLE_ERROR is only for error handling for credit card
    case SHOW_ORDER_SERVICE_UNAVAILABLE_ERROR:
      return deepmerge(state, {
        showOrderServiceUnavailableError:
          action.showOrderServiceUnavailableError
      })
    case FETCH_ORDERDRAFT_SUCCESS:
      return deepmerge(state, {
        isPaymentLoading: false,
        showOrderServiceUnavailableError: false
      })
    case FETCH_DOOR_DELIVERY_ADDRESSES_REQUEST:
      return deepmerge(state, {
        hasDoorDeliveryFetched: false
      })
    case FETCH_DOOR_DELIVERY_ADDRESSES_SUCCESS:
      return deepmerge(state, {
        addresses: action.doorDeliveryAddresses,
        hasDoorDeliveryFetched: true
      })
    case FETCH_PUP_ADDRESSES_REQUEST:
      return deepmerge(state, {
        hasPupFetched: false
      })
    case FETCH_PUP_ADDRESSES_SUCCESS:
      return deepmerge(state, {
        addresses: action.pupAddresses,
        hasPupFetched: true
      })
    case UPDATE_ORDERDRAFT:
      return deepmerge(
        state,
        {
          orderDraft: action.orderDraft,
          showOrderServiceUnavailableError: false
        },
        { arrayMerge: overwriteMerge }
      )
    case FETCH_SHIPPING_OPTIONS_SUCCESS:
      return deepmerge(
        state,
        {
          shippingOptions: action.shippingOptions
        },
        { arrayMerge: overwriteMerge }
      )
    case SELECT_SHIPPING_OPTION:
      return deepmerge(state, {
        selectedShippingOptions: {
          [action.subOrderId]: {
            identifier: action.identifier,
            costs: action.costs,
            displayName: action.displayName
          }
        }
      })
    case FETCH_REDPOINTS_STATUS_SUCCESS:
      return deepmerge(state, {
        redPointsStatus: action.redPointsStatus
      })
    case FETCH_NEW_CUSTOMER_SUCCESS:
      return deepmerge(state, {
        newCustomerStatus: action.newCustomerStatus
      })
    case SET_SHIPPING_OPTION_INFO: {
      return state
    }
    case ADD_ADDRESS:
      return deepmerge(state, {
        addresses: { [action.addressId]: { ...action.address } }
      })
    case CHANGE_ADDRESS_SUCCESS:
      return deepmerge(state, {
        addresses: { [action.address.id]: { ...action.address } }
      })
    case CHECKOUT_ERROR:
      return deepmerge(state, {
        showOrderServiceUnavailableError: !IS_STORYBOOK
      })
    case SET_SHIPPING_ADDRESS_INFO:
      return state
    case SET_DEFAULT_SHIPPING_ADDRESS_ID:
      return deepmerge(state, {
        defaultShippingId: action.shippingAddressId
      })
    case SET_ADDRESS_TYPE:
      return deepmerge(state, {
        addresses: {
          [action.addressId]: {
            type: action.addressType
          }
        }
      })
    case SET_CURRENT_STEP:
      return deepmerge(state, {
        currentStep: action.stepNo
      })
    case SET_PHONENUMBER:
      return deepmerge(state, {
        orderDraft: {
          customerMasterData: {
            phoneNumber: action.phoneNumber
          }
        }
      })
    case SET_REDPOINTS_REGISTRATION:
      return deepmerge(state, {
        verification: {
          registerForRedPoints: action.registerForRedPoints
        }
      })
    default:
      return state
  }
}
export default reducer
